import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import Intro from "./components/Intro";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { SmoothScrollProvider } from "./lib/smoothScroll";
import usePageTracking from "./hooks/usePageTracking";
import useTitleReveals from "./lib/useTitleReveals";
import { profile } from "./data/profile";

export default function App() {
  usePageTracking();
  useTitleReveals();

  useEffect(() => {
    document.title = `${profile.name} | ${profile.role}`;
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <SmoothScrollProvider>
        <a className="skip-link" href="#work">
          Skip to work
        </a>
        <Intro />
        <Nav />
        <main id="main">
          <Hero />
          <About />
          <Projects />
          <Experience />
          <Skills />
          <Contact />
        </main>
        <Footer />
      </SmoothScrollProvider>
    </MotionConfig>
  );
}
